<template>
  <el-form ref="form" size="mini" label-width="110px">
    <el-form-item label="赠送条件" class="is-required" prop="GiveCondition">
      <el-checkbox v-model="data.HasLevel" @change="selectLevel" style="display:block">会员等级</el-checkbox>
      <!-- <el-checkbox v-model="data.HasScore" style="display:block">累计积分</el-checkbox> -->
      <el-checkbox v-model="data.HasCost" style="display:block">累计消费</el-checkbox>
      <el-checkbox v-model="data.HasCostDuration" style="display:block">消费时间段</el-checkbox>
      <el-checkbox v-model="data.HasNoCostDuration" style="display:block">无消费时间段</el-checkbox>
      <div style="color:#999;font-size:12px">* 需同时满足所有勾选的赠送条件的会员才能获赠</div>
    </el-form-item>
    <el-form-item label="会员等级" prop="LevelId" v-if="data.HasLevel">
      <el-select v-model="data.LevelId">
        <el-option :value="i.RecordId" v-for="(i, idx) in Levels" :key="idx" :label="i.GradeName"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="累计积分" required style="margin-bottom:0px" v-if="data.HasScore">
      <div style="display:flex">
        <el-form-item prop="StartPoint">
          <el-input-number v-model="data.StartPoint" :controls="false" style="width:150px"></el-input-number>
        </el-form-item>
        <div style="padding:0 10px">~</div>
        <el-form-item prop="EndPoint">
          <el-input-number v-model="data.EndPoint" :controls="false" style="width:150px"></el-input-number>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item label="累计消费" required style="margin-bottom:0px" v-if="data.HasCost">
      <div style="display:flex">
        <el-form-item prop="StartAmount">
          <el-input-number v-model="data.StartAmount" :controls="false" style="width:150px"></el-input-number>
        </el-form-item>
        <div style="padding:0 10px">~</div>
        <el-form-item prop="EndAmount">
          <el-input-number v-model="data.EndAmount" :controls="false" style="width:150px"></el-input-number>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item label="无消费时间段" required style="margin-bottom:0px" v-if="data.HasNoCostDuration">
      <div style="display:flex">
        <el-form-item prop="UnStartDate">
          <el-date-picker
            v-model="data.UnStartDate"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
            style="width:150px"
          ></el-date-picker>
        </el-form-item>
        <div style="padding:0 10px">~</div>
        <el-form-item prop="UnEndDate">
          <el-date-picker
            v-model="data.UnEndDate"
            placeholder="选择结束日期"
            value-format="yyyy-MM-dd"
            style="width:150px"
          ></el-date-picker>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item label="有消费时间段" required style="margin-bottom:0px" v-if="data.HasCostDuration">
      <div style="display:flex">
        <el-form-item prop="StartDate">
          <el-date-picker
            v-model="data.StartDate"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
            style="width:150px"
          ></el-date-picker>
        </el-form-item>
        <div style="padding:0 10px">~</div>
        <el-form-item prop="EndDate">
          <el-date-picker
            v-model="data.EndDate"
            placeholder="选择结束日期"
            value-format="yyyy-MM-dd"
            style="width:150px"
          ></el-date-picker>
        </el-form-item>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button v-if="$permission.canEdit()"  type="primary" size="mini" @click="submit">确定赠送</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      api: require("@/api/sale/couponCustomer").default,
      level_api: require("@/api/shop/grade").default,
      canEdit: false,
      data: {
        CouponId: 0,

        HasLevel: false,
        HasScore: false,
        HasCost: false,
        HasCostDuration: false,
        HasNoCostDuration: false,

        LevelId: 0,
        StartPoint: 0, //累计积分 - 开始
        EndPoint: 0, //累计积分 - 结束
        StartAmount: 0, //累计消费 - 开始
        EndAmount: 0, //累计消费 - 结束
        StartDate: null, //有消费时间段 - 开始
        EndDate: null, //有消费时间段 - 结束
        UnStartDate: null, //无消费时间段 - 开始
        UnEndDate: null, //无消费时间段 - 结束
      },
      Levels: [],
    };
  },
  mounted() {
    this.canEdit = this.$permission.canEdit();
    console.log(this.$permission.canEdit(),"canEdit");
  },
  methods: {
    init() {
      
      this.level_api.list({}).then((res) => {
        this.Levels = res.Data;
      });
    },
    setData(CouponId) {
      
      this.data.CouponId = CouponId;
    },
    selectLevel(value) {
      
      if (this.data.HasLevel) {
        this.data.LevelId = null;
      } else {
        this.data.LevelId = 0;
      }
    },
    submit() {
      
      this.$confirm("确认赠送吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.manualSend(this.data).then((res) => {
            
            this.$message({
              message: res.Msg,
              type: res.Code == 0 ? "success" : "error",
              duration: 3000,
            });
          });
        })
        .catch(() => {});
    },
    clear() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>